<app-hourglass *ngIf="!pageLoad || requestCount > 0"></app-hourglass>
<mat-card *ngIf="pageLoad" class="formCard">
    <mat-card-header>
        <mat-card-title>Admin Settings</mat-card-title>
        <div class="cache-refresh">
            <div *ngIf="lastCacheRefresh" class="cache-refresh-timestamp">
                Last manually refreshed: {{lastCacheRefresh | date:'medium'}}
            </div>
            <button (click)="refreshCache()" [disabled]="refreshingCache" class="cacheRefresh"
                    mat-raised-button>Refresh Cache
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="settings">
            <mat-card class="full-width">
                <div class="toggle-format">
                    <label>News Banner</label>
                </div>
                <mat-form-field class="news-color">
                    <mat-select [(ngModel)]="settings[NEWS_COLOR]">
                        <mat-option value="--cmn-primary">Blue</mat-option>
                        <mat-option value="--cmn-accent">Green</mat-option>
                        <mat-option value="--cmn-warn-darker">Orange</mat-option>
                        <mat-option value="--cmn-error">Red</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="news">
                    <input matInput [(ngModel)]="settings[NEWS]" maxLength="255" >
                    <mat-hint align="end" class="right">{{settings[NEWS].length || "0"}} /255</mat-hint>
                </mat-form-field>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_LDAP_SYNC]" class="toggle" color="primary"
                                          name="ldap_sync"></mat-slide-toggle>
                        <label>Sync with LDAP ( job runs {{settings[LDAP_SYNC_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Process to remove associates from SS&C Alerting that are no longer employed</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_LDAP_SYNC_SUCCESS_TIMESTAMP] | date:'medium'" matInput
                                   readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_LDAP_SYNC_ATTEMPT_TIMESTAMP] | date:'medium'" matInput
                                   readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[LDAP_SYNC_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[LDAP_SYNC_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <mat-slide-toggle [(ngModel)]="settings[DO_ON_CALL]" class="toggle" color="primary"
                                      name="on_call_toggle"></mat-slide-toggle>
                    <label>Automate Group Member Rotation ( job runs {{settings[ON_CALL_JOB_FREQUENCY]}} )</label>
                </div>
                <div class="toggle-format">
                    <em>Process Group schedules to rotate membership (e.g. on-call rotation)</em>
                </div>
                <div class="num-format">
                    <label>Last Success Timestamp: </label>
                    <mat-form-field class="num-field">
                        <input [ngModel]="settings[LAST_ON_CALL_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                    </mat-form-field>
                </div>
                <div class="num-format">
                    <label>Last Attempt Timestamp: </label>
                    <mat-form-field class="num-field">
                        <input [ngModel]="settings[LAST_ON_CALL_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                    </mat-form-field>
                </div>
                <div class="num-format">
                    <label>Delete schedules completed more than this many days ago: </label>
                    <mat-form-field class="num-field">
                        <input [ngModel]="settings[SCHEDULE_PURGE_AGE]" (ngModelChange)="deleteScheduleDaysChange($event)" matInput>
                    </mat-form-field>
                </div>
                <div *ngIf="settings[ON_CALL_JOB_ERROR]" class="error">
                    <textarea [ngModel]="settings[ON_CALL_JOB_ERROR]" matInput readonly rows="5"></textarea>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_ESCAL]" class="toggle" color="primary"
                                          name="escalation_toggle"></mat-slide-toggle>
                        <label>Send Reminders and Escalations ( job runs {{settings[ESCAL_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>For messages or alerts requesting acknowledgement, send reminders and escalations at set intervals (override per group)</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_ESCAL_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_ESCAL_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Global Escalation Interval (min)*: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [(ngModel)]="settings[ESCALATION_INTERVAL]"
                                   (ngModelChange)="EscalateTimeChange($event)"
                                   matInput name="escalate_time_limit"
                                   type="number">
                            <mat-hint align="end">0-99</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Global Reminder Interval (min)*: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [(ngModel)]="settings[REMINDER_INTERVAL]"
                                   (ngModelChange)="EscalateTimeChange($event)"
                                   matInput
                                   name="reminder_interval"
                                   type="number">
                            <mat-hint align="end">0-99</mat-hint>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[ESCAL_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[ESCAL_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_MESSAGE_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Message Purge ( job runs {{settings[MESSAGE_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge messages older than the retention period.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_MESSAGE_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_MESSAGE_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Message Retention (dd:hh:mm)*: </label>
                        <mat-form-field class="num-field">
                            <input [(ngModel)]="settings[MESSAGE_RETENTION]"
                                   (ngModelChange)="MessageRetentionChange($event)"
                                   matInput>
                            <mat-hint align="end">dd:hh:mm</mat-hint>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[MESSAGE_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[MESSAGE_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_INDIVIDUAL_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Individual Purge ( job runs {{settings[INDIVIDUAL_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge inactive individuals.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_INDIVIDUAL_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_INDIVIDUAL_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[INDIVIDUAL_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[INDIVIDUAL_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_CONTACT_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Contact Purge ( job runs {{settings[CONTACT_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge inactive contacts.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_CONTACT_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_CONTACT_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[CONTACT_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[CONTACT_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_DEVICE_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Device Purge ( job runs {{settings[DEVICE_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge inactive channels.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_DEVICE_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_DEVICE_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[DEVICE_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[DEVICE_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_GROUP_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Group Purge ( job runs {{settings[GROUP_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge inactive groups.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_GROUP_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_GROUP_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[GROUP_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[GROUP_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_ORPHAN_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Orphan Purge  ( job runs {{settings[ORPHAN_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em> Replace orphaned group members, notification to's, and escalate to's.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_ORPHAN_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_ORPHAN_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[ORPHAN_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[ORPHAN_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_TEMPLATE_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Template Purge ( job runs {{settings[TEMPLATE_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge inactive templates.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_TEMPLATE_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_TEMPLATE_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[TEMPLATE_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[TEMPLATE_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[DO_TOKEN_PURGE]" class="toggle" color="primary"
                                          name="purge_toggle"></mat-slide-toggle>
                        <label>Token Purge ( job runs {{settings[TOKEN_PURGE_JOB_FREQUENCY]}} )</label>
                    </div>
                    <div class="toggle-format">
                        <em>Purge orphaned tokens.</em>
                    </div>
                    <div class="num-format">
                        <label>Last Success Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_TOKEN_PURGE_SUCCESS_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div class="num-format">
                        <label>Last Attempt Timestamp: </label>&nbsp;
                        <mat-form-field class="num-field">
                            <input [ngModel]="settings[LAST_TOKEN_PURGE_ATTEMPT_TIMESTAMP] | date:'medium'" matInput readonly>
                        </mat-form-field>
                    </div>
                    <div *ngIf="settings[TOKEN_PURGE_JOB_ERROR]" class="error">
                        <textarea [ngModel]="settings[TOKEN_PURGE_JOB_ERROR]" matInput readonly rows="5"></textarea>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">

            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <mat-slide-toggle [(ngModel)]="settings[NOTIFICATION_OVERRIDE]" class="toggle" color="primary"
                                      name="on_call_toggle"></mat-slide-toggle>
                    <label>Notification Override</label>
                </div>
                <div class="num-format">
                    <label>Default Notification Channel*: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <input [(ngModel)]="settings[DEFAULT_NOTIFICATION]"
                               matInput
                               name="default_notification"
                               type="text">
                    </mat-form-field>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <label>Recipient Warning Threshold:</label>
                </div>
                <div class="num-format">
                    <label>Message Count*: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <input [(ngModel)]="settings[RECIPIENT_WARNING]"
                               (ngModelChange)="recipientWarningChange($event)"
                               matInput
                               name="recipient_threshold"
                               type="text">
                    </mat-form-field>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <label>Acknowledgement Expiration Time:</label>
                </div>
                <div class="num-format">
                    <label>Minutes*: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <input [(ngModel)]="settings[TOKEN_EXPIRATION]"
                               (ngModelChange)="tokenExpirationChange($event)"
                               matInput
                               name="recipient_threshold"
                               type="text">
                    </mat-form-field>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <label>Message Status V2 Auto-Refresh Interval:</label>
                </div>
                <div class="num-format">
                    <label>Minutes*: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <input [(ngModel)]="settings[MESSAGE_STATUS_V2_REFRESH_INTERVAL]"
                               (ngModelChange)="messageStatusV2RefreshChange($event)"
                               matInput
                               name="message_status_v2_refresh"
                               type="text">
                    </mat-form-field>
                </div>
                <div class="toggle-format">
                    <em>Controls how frequently the Message Status V2 screen auto-refreshes. Set to 0 to disable auto-refresh completely.</em>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_MESSAGE_TYPE]" class="toggle" color="primary"
                                          name="ff_message_type"></mat-slide-toggle>
                        <label>Send to Multiple Contacts V2 ({{ settings[FF_MESSAGE_TYPE] ? 'V2 - on' : 'V1 - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Routes messages to V2 flow when this flag and the corresponding type flag (right) are both on. Also allows V2 escalations to run if 'Escalation V2' is enabled. Toggle off to roll ALL types back to V1 and block V2 escalations from running. Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_ACK_DEEP_LINK]" class="toggle" color="primary"
                                          name="ff_ack_deep_link"></mat-slide-toggle>
                        <label>Acknowledgement Deep Link ({{ settings[FF_ACK_DEEP_LINK] ? 'V2 deep link - on' : 'V1 token URL - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Includes the V2 deep-link acknowledgement URL in outbound messages when on; falls back to the V1 token URL when off. Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
            </mat-card>
            <mat-card class="settings-card">
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_MESSAGE_V2]" class="toggle" color="primary"
                                          name="ff_message_type"></mat-slide-toggle>
                        <label>Send Message V2 ({{ settings[FF_MESSAGE_V2] ? 'V2 - on' : 'V1 - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Routes messages sent through the UI and Send Message endpoints to V2 flow when this flag and 'Send to Multiple Contacts V2' are both on. Toggle off to roll Send Message back to V1. Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_ALERTMANAGER_V2]" class="toggle" color="primary"
                                          name="ff_message_type"></mat-slide-toggle>
                        <label>Alert Manager V2 ({{ settings[FF_ALERTMANAGER_V2] ? 'V2 - on' : 'V1 - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Routes Alert Manager messages to V2 flow when this flag and 'Send to Multiple Contacts V2' are both on. Toggle off to roll Alert Manager messages back to V1. Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_PAGERDUTY_V2]" class="toggle" color="primary"
                                          name="ff_message_type"></mat-slide-toggle>
                        <label>Pager Duty V2 ({{ settings[FF_PAGERDUTY_V2] ? 'V2 - on' : 'V1 - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Routes Pager Duty messages to V2 flow when this flag and 'Send to Multiple Contacts V2' are both on. Toggle off to roll Pager Duty back to V1. Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
                <div class="setting">
                    <div class="toggle-format">
                        <mat-slide-toggle [(ngModel)]="settings[FF_ESCALATION_V2]" class="toggle" color="primary"
                                          name="ff_message_type"></mat-slide-toggle>
                        <label>Escalation V2 ({{ settings[FF_ESCALATION_V2] ? 'V2 - on' : 'V1 - off' }})</label>
                    </div>
                    <div class="toggle-format">
                        <em>Allows the V2 escalation process to run when this flag, 'Send to Multiple Contacts V2', and 'Send Reminders and Escalations' (above) are all on. Toggle off to stop V2 escalations from running (note that the V1 escalation process is not affected by this flag). Takes effect within the 5-minute Settings cache refresh.</em>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="toggle-format">
                    <label>Alert Manager Alerts Cap:</label>
                </div>
                <div class="num-format">
                    <label>Mode: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <mat-select [(ngModel)]="settings[AM_ALERTS_CAP_MODE]" name="am_alerts_cap_mode">
                            <mat-option *ngFor="let mode of AM_ALERTS_CAP_MODES" [value]="mode">{{ mode }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="num-format">
                    <label>Max alerts per request*: </label>&nbsp;
                    <mat-form-field class="num-field">
                        <input [(ngModel)]="settings[AM_ALERTS_CAP]"
                               (ngModelChange)="alertsCapChange($event)"
                               matInput
                               name="am_alerts_cap"
                               type="text">
                    </mat-form-field>
                </div>
                <div class="toggle-format">
                    <em>Limits the number of alerts in one Alert Manager webhook request (V2 only). OFF: not checked. LOG: over-cap requests are counted and logged but still delivered. ENFORCE: over-cap requests are rejected with 413 and nothing is delivered. Takes effect within the 5-minute Settings cache refresh.</em>
                </div>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="full-width">
                <div class="cmn-flex row space-between rate-limit-header">
                    <div class="toggle-format">
                        <label>Rate Limit Exceptions</label>
                    </div>
                    <button (click)="openRateLimitOverridePopup()" color="primary" mat-raised-button>Add exception</button>
                </div>
                <div class="toggle-format">
                    <em>Per caller limits that replace the defaults for one area. Blank limits use the default. Changes are saved immediately (not with the Save button below) and take effect within 5 minutes.</em>
                </div>
                <table *ngIf="rateLimitOverrides.length; else noRateLimitOverrides" [dataSource]="rateLimitOverrides"
                       class="full-width rate-limit-table" mat-table>
                    <ng-container matColumnDef="caller">
                        <th *matHeaderCellDef mat-header-cell>Caller</th>
                        <td *matCellDef="let o" mat-cell>{{ o.caller }}</td>
                    </ng-container>
                    <ng-container matColumnDef="route_group">
                        <th *matHeaderCellDef mat-header-cell>Area</th>
                        <td *matCellDef="let o" mat-cell>{{ routeGroupLabels[o.route_group] || o.route_group }}</td>
                    </ng-container>
                    <ng-container matColumnDef="replenish_rate">
                        <th *matHeaderCellDef mat-header-cell>Requests / min</th>
                        <td *matCellDef="let o" [class.default-value]="!o.replenish_rate" mat-cell>{{ o.replenish_rate || 'Default' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="burst_capacity">
                        <th *matHeaderCellDef mat-header-cell>Burst</th>
                        <td *matCellDef="let o" [class.default-value]="!o.burst_capacity" mat-cell>{{ o.burst_capacity || 'Default' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="alert_cap">
                        <th *matHeaderCellDef mat-header-cell>Max alerts / request</th>
                        <td *matCellDef="let o" [class.default-value]="!o.alert_cap" mat-cell>
                            {{ o.route_group === 'alertManager' ? (o.alert_cap || 'Default') : '-' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ticket">
                        <th *matHeaderCellDef mat-header-cell>Ticket</th>
                        <td *matCellDef="let o" [matTooltip]="o.justification" mat-cell>{{ o.ticket }}</td>
                    </ng-container>
                    <ng-container matColumnDef="expires_at">
                        <th *matHeaderCellDef mat-header-cell>Expires</th>
                        <td *matCellDef="let o" mat-cell>{{ o.expires_at ? (o.expires_at | date:'mediumDate') : 'Never' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th *matHeaderCellDef mat-header-cell>Status</th>
                        <td *matCellDef="let o" mat-cell>{{ o.active ? 'Active' : (o.enabled ? 'Expired' : 'Disabled') }}</td>
                    </ng-container>
                    <ng-container matColumnDef="last_modified_date">
                        <th *matHeaderCellDef mat-header-cell>Last modified</th>
                        <td *matCellDef="let o" mat-cell>{{ o.last_modified_date | date:'short' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="last_modified_by">
                        <th *matHeaderCellDef mat-header-cell>Modified by</th>
                        <td *matCellDef="let o" mat-cell>{{ o.last_modified_by }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th *matHeaderCellDef mat-header-cell></th>
                        <td *matCellDef="let o" mat-cell>
                            <button (click)="openRateLimitOverridePopup(o)" aria-label="Edit exception" mat-icon-button>
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button (click)="removeRateLimitOverride(o)" aria-label="Delete exception" mat-icon-button>
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr *matHeaderRowDef="rateLimitOverrideColumns" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: rateLimitOverrideColumns" mat-row></tr>
                </table>
                <ng-template #noRateLimitOverrides>
                    <div class="toggle-format"><em>No exceptions. All callers use the default limits.</em></div>
                </ng-template>
            </mat-card>
        </div>
        <div class="settings">
            <mat-card class="settings-card">
                <div class="owner-field">
                    <label>Default Group Owners: </label>
                    <mat-chip-list #oChipList>
                        <mat-chip *ngFor="let groupOwner of settings[DEFAULT_GROUP_OWNERS]">
                            {{ groupOwner }}
                            <mat-icon (click)="removeChip(DEFAULT_GROUP_OWNERS, groupOwner)" matChipRemove>cancel
                            </mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <mat-form-field class="owner-field">
                        <input [(ngModel)]="groupOwnerInput"
                               (ngModelChange)="individualsChange.next($event)"
                               [matAutocomplete]="ownerAC"
                               [matChipInputFor]="oChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               autoActiveFirstOption
                               class="owner-field" matInput>
                        <mat-autocomplete #ownerAC="matAutocomplete" (optionSelected)="addOwner($event.option.value)">
                            <mat-option *ngFor="let individual of individualsAuto" [value]="individual">
                                {{ individual.full_name }} ({{ individual.external_id }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="owner-field">
                    <label>Default Group Members: </label>
                    <mat-chip-list #mChipList>
                        <mat-chip *ngFor="let groupMember of settings[DEFAULT_GROUP_MEMBERS]">
                            {{ groupMember }}
                            <mat-icon (click)="removeChip(DEFAULT_GROUP_MEMBERS, groupMember)" matChipRemove>cancel
                            </mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <mat-form-field class="owner-field">
                        <input [(ngModel)]="groupMemberInput"
                               (ngModelChange)="indsAndDevicesChange.next($event)"
                               [matAutocomplete]="memberAC"
                               [matChipInputFor]="mChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               autoActiveFirstOption
                               class="owner-field" matInput>
                        <mat-autocomplete #memberAC="matAutocomplete" (optionSelected)="addMember($event.option.value)">
                            <mat-option *ngFor="let recip of indsAndDevices" [value]="recip">
                                {{ recip.full_name ? recip.full_name : recip.name }}
                                ({{ recip.external_id ? recip.external_id : recip.id }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="owner-field">
                    <label>Default SuperGroup Members: </label>
                    <mat-chip-list #sChipList>
                        <mat-chip *ngFor="let sGroupMember of settings[DEFAULT_SUPER_GROUP_MEMBERS]">
                            {{ sGroupMember }}
                            <mat-icon (click)="removeChip(DEFAULT_SUPER_GROUP_MEMBERS, sGroupMember)" matChipRemove>
                                cancel
                            </mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <mat-form-field class="owner-field">
                        <input [(ngModel)]="superGroupMemberInput"
                               (ngModelChange)="groupChange.next($event)"
                               [matAutocomplete]="superAC"
                               [matChipInputFor]="sChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               autoActiveFirstOption
                               class="owner-field" matInput>
                        <mat-autocomplete #superAC="matAutocomplete"
                                          (optionSelected)="addSuperMember($event.option.value)">
                            <mat-option *ngFor="let group of groupsAuto" [value]="group">
                                {{ group.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="owner-field">
                    <label>Group Types: </label>
                    <mat-chip-list #gTypeChipList (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListOrientation="vertical">
                        <mat-chip (click)="openGroupTypePopup(gType, i)" *ngFor="let gType of groupTypes; let i = index"
                                  [disabled]="!pageLoad" class="groupTypeChip" cdkDrag>
                            <div class="groupTypeText">{{ gType.group_type }} - {{ gType.group_type_desc }}</div>
                            <mat-icon (click)="removeGroupType(gType)" matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <mat-form-field class="owner-field">
                        <input [(ngModel)]="groupTypeName" (matChipInputTokenEnd)="addGroupType($event)"
                               [matChipInputFor]="gTypeChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               class="owner-field"
                               matInput placeholder="New Group Type">
                    </mat-form-field>
                </div>
            </mat-card>
            <mat-card class="settings-card countrycodes">
                <div class="owner-field">
                    <div class="toggle-format">
                        <label>Country Codes</label>
                    </div>

                    <div class="countryCodeChipList">
                        <mat-chip-list #chipListCountryCodes aria-label="Country Codes">
                            <mat-chip *ngFor="let countryCode of countryCodes; let i = index" [attr.data-index]="i" class="countryCodeChip">
                                {{countryCode.phone_code}} - {{countryCode.country}}
                            </mat-chip>
                        </mat-chip-list>
                    </div>
                </div>
                <div class="owner-field contactTypeCard pt-6">
                    <label>Contact Types: </label>
                    <mat-chip-list #cTypeChipList (cdkDropListDropped)="drop($event)" cdkDropList cdkDropListOrientation="vertical">
                        <mat-chip (click)="openContactTypePopup(cType, i)" *ngFor="let cType of contactTypes; let i = index"
                                  [disabled]="!pageLoad" cdkDrag>
                            <mat-icon *ngIf="cType.admin_only" class="contactTypeIcon" matChipAvatar>star</mat-icon>
                            <div>{{ cType.contact_type }}</div>
                            <mat-icon (click)="removeContactType(cType)" matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                    <mat-form-field class="owner-field">
                        <input [(ngModel)]="contactTypeName" (matChipInputTokenEnd)="addContactType($event)"
                               [matChipInputFor]="cTypeChipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               class="owner-field"
                               matInput placeholder="New Contact Type">
                    </mat-form-field>
                </div>
            </mat-card>
        </div>
        <div>
            <button (click)="updateSetting();" [disabled]="canSave()" class="settingsSave" mat-raised-button>Save
            </button>
        </div>
    </mat-card-content>
</mat-card>

